export default "/images/ic_close_orange.svg?e0021a724d1679031301d640f8e0cb9e";